import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import {Checkbox, Form, Header, Icon, Message, Container} from 'semantic-ui-react';
import {isNil} from 'ramda';
import styled from 'styled-components';
import {signup} from '../../api';
import CodeOfConductPdf from '../../security/code-of-conduct.pdf';
import PrivacyPolicyPdf from '../../security/privacy-policy.pdf';
import {saveUser} from '../../util/Session';
import {FormInputLogin, FormSelectLogin} from './FormInputMix';
import {ButtonsGroup, DefaultButton, GreenButton} from '../Button/ButtonMix';

const Footer = styled.div`
  margin: 30px 0 20px;
  & p {
    color: #222222;
  }
  & .checkbox {
    margin-bottom: 20px;
    & label {
      color: #222222;
      & a {
        color: #0A8DE2
        text-decoration: underline;
      }
    }
  }
`;


class CreateSchoolForm extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      error: null,
      schoolName: '',
      schoolCode: '',
      schoolTimeZone: 'America/Denver',
      schoolContactName: '',
      schoolContactEmail: '',
      schoolContactPhone: '',
      schoolAddress: '',
      schoolCity: '',
      schoolState: '',
      schoolZipCode: '',
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      verifyPassword: '',
      isAgreedToPrivacyPolicy: false,
      isParentalConsent: false
    };
  }
  
  handleChange = (e, {name, value}) => {
    this.setState({error: null, [name]: value});
  };
  
  handleCheckboxChange = (e, {name}) => this.setState({[name]: !this.state[name]});
  
  handleSubmit = () => {
    const {router} = this.props;
    const {
      schoolName,
      schoolCode,
      schoolTimeZone,
      schoolContactName,
      schoolContactEmail,
      schoolContactPhone,
      schoolAddress,
      schoolCity,
      schoolState,
      schoolZipCode,
      firstName,
      lastName,
      email,
      password,
      verifyPassword
    } = this.state;
    
    const isSchoolCodeValid = schoolCode && schoolCode.length === 6;
    this.setState({error: !isSchoolCodeValid ? 'Invalid school code (code must be 6 characters long)' : null});
    
    if (!isSchoolCodeValid) return;
    
    const school = {
      name: schoolName,
      code: schoolCode,
      time_zone: schoolTimeZone,
      contact_name: schoolContactName,
      contact_email: schoolContactEmail,
      contact_phone: schoolContactPhone,
      address: schoolAddress,
      city: schoolCity,
      state: schoolState,
      zip_code: schoolZipCode
    };
    const user = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      password: password,
      password_confirmation: verifyPassword
    };
    return signup(school, user)
      .then(response => {
        const createdUser = response.data.user;
        saveUser(createdUser);
        router.push('/dashboard');
        return null;
      })
      .catch(e => {
        e.response ? this.setState({error: e.response.data.error}) : this.setState({error: e.message});
      });
  };
  
  render() {
    const {router} = this.props;
    const {
      error,
      firstName,
      isAgreedToPrivacyPolicy,
      isParentalConsent,
      lastName,
      email,
      password,
      verifyPassword,
      schoolName,
      schoolCode,
      schoolTimeZone,
      schoolContactName,
      schoolContactEmail,
      schoolContactPhone,
      schoolAddress,
      schoolCity,
      schoolState,
      schoolZipCode
    } = this.state;
    
    const isSubmitButtonEnabled = isAgreedToPrivacyPolicy && isParentalConsent;

    const label = <label>I acknowledge I have read and agree to the Terms of Use, <a href={CodeOfConductPdf} rel="noopener noreferrer" target="_blank"> Code of Conduct</a>, and <a href={PrivacyPolicyPdf} rel="noopener noreferrer" target="_blank"> Privacy Policy</a>.</label>;
  
    const timeZoneOptions = [
      { key: 'p', text: 'Pacific', value: 'America/Los_Angeles' },
      { key: 'm', text: 'Mountain', value: 'America/Denver' },
      { key: 'c', text: 'Central', value: 'America/Chicago' },
      { key: 'e', text: 'Eastern', value: 'America/New_York' }
    ];

    return (
      <Form error={!isNil(error)} onSubmit={this.handleSubmit}>
        <Container textAlign="center" style={{color: '#ffffff'}}>
          <p>Fill out the form below to create a new BodyBank account and continue to select plan and payment.</p>
        </Container>
        <div>
          <Header as="h4" icon textAlign="left" style={{color: '#ffffff', marginTop: '20px'}}>
            <Header.Content>School Information </Header.Content>
          </Header>
          <FormInputLogin fluid value={schoolName} label="School name" type="text" name="schoolName" onChange={this.handleChange} required/>
          <FormInputLogin fluid value={schoolCode} label="Create your school code (must be 6 characters)" type="text" name="schoolCode" onChange={this.handleChange} required/>
          <FormSelectLogin fluid value={schoolTimeZone} label="School time zone" type="text" name="schoolTimeZone" options={timeZoneOptions} onChange={this.handleChange} required/>
        </div>
        <div>
          <Header as="h4" icon textAlign="left" style={{color: '#ffffff', marginTop: '20px'}}>
            <Header.Content>School Contact Information </Header.Content>
          </Header>
          <FormInputLogin fluid value={schoolContactName} label="Principal name" type="text" name="schoolContactName" onChange={this.handleChange} required/>
          <FormInputLogin fluid value={schoolContactEmail} label="Principal email" type="text" name="schoolContactEmail" onChange={this.handleChange} required/>
          <FormInputLogin fluid value={schoolContactPhone} label="Principal phone number" type="text" name="schoolContactPhone" onChange={this.handleChange} required/>
          <FormInputLogin fluid value={schoolAddress} label="Street address" type="text" name="schoolAddress" onChange={this.handleChange} required/>
          <FormInputLogin fluid value={schoolCity} label="City" type="text" name="schoolCity" onChange={this.handleChange} required/>
          <FormInputLogin fluid value={schoolState} label="State" type="text" name="schoolState" onChange={this.handleChange} required/>
          <FormInputLogin fluid value={schoolZipCode} label="Zip code" type="text" name="schoolZipCode" onChange={this.handleChange} required/>
        </div>
        <div>
          <Header as="h4" icon textAlign="left" style={{marginTop: '20px', color: '#ffffff'}}>
            <Header.Content>Coordinator Information </Header.Content>
          </Header>
          <FormInputLogin fluid value={firstName} label="First Name" type="text" name="firstName" placeholder="First Name" onChange={this.handleChange} required/>
          <FormInputLogin fluid value={lastName} label="Last Name" type="text" name="lastName" placeholder="Last Name" onChange={this.handleChange} required/>
          <FormInputLogin value={email} label="Email" name="email" type="text" placeholder="Email" onChange={this.handleChange} required/>
          <FormInputLogin value={password} label="Password" type="password" name="password" placeholder="Password" onChange={this.handleChange} required/>
          <FormInputLogin value={verifyPassword} label="Verify Password" type="password" name="verifyPassword" placeholder="Verify Password" onChange={this.handleChange} required/>
        </div>
        <Footer>
          <Checkbox
            id="parentalConsentCheckbox"
            name="isParentalConsent"
            onChange={this.handleCheckboxChange}
            required
            label="You certify that your school has obtained parental consent for students under 13 to use BodyBank."
          />
          <Checkbox
            id="privacyPolicyCheckbox"
            name="isAgreedToPrivacyPolicy"
            onChange={this.handleCheckboxChange}
            required
            label={label}
          />
          <p>
            Your name & points may be shared with team members and certain school officials specific to your account for the reward programs related to BodyBank.
          </p>
        </Footer>
        <Message error icon>
          <Icon name="exclamation triangle"/>
          <Message.Content>
            <Message.Header>Error</Message.Header>
            {error}
          </Message.Content>
        </Message>
        <ButtonsGroup>
          <DefaultButton onClick={router.goBack}>Cancel</DefaultButton>
          <GreenButton fluid disabled={!isSubmitButtonEnabled}>Create</GreenButton>
        </ButtonsGroup>
      </Form>
    );
  }
}

CreateSchoolForm.propTypes = {
  router: PropTypes.object.isRequired
};

export default withRouter(CreateSchoolForm);



// WEBPACK FOOTER //
// ./src/components/Form/CreateSchoolForm.js